<template>
  <div :class="classObj" class="app-wrapper">
    <logoUploading />
    <baojingmassage />
    <amend-pass />
    <child-management />
    <child-urgency />
    <popup />

    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    ></div>
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
// import Dept_ltxa from '@/components/Dept_ltxa/dept_ltxa.vue'
// import Subordinate from '@/components/Subordinate/subordinate.vue' // 加上vue会报红
// import Monitoring from '@/components/Subordinate/monitoring.vue' // 加上vue会报红

import logoUploading from '@/components/logoUploading/index'
import baojingmassage from '@/components/baojingmassage/index'
import AmendPass from '@/components/amendPass/amendPass.vue'
import ChildManagement from '@/components/childManagement/childManagement.vue'
import childUrgency from '@/components/childUrgency/index.vue'
// import { Dept, logout, getInfo } from '@/api/dept'

import { cycleRequest } from '@/api/alarm.js'
import Popup from '@/views/receivingAlarm/components/Popup.vue'

export default {
  name: 'Layout',
  components: {
    AppMain,
    // Subordinate,
    Navbar,
    RightPanel,
    Settings,
    // Monitoring,
    Sidebar,
    TagsView,
    // Dept_ltxa,
    logoUploading, // 图片上传
    baojingmassage,
    AmendPass,
    ChildManagement,
    childUrgency,
    Popup
  },
  mixins: [ResizeMixin],
  data() {
    return {
      MethodUserId: '',
      root: '',
      CheckDeletValue: '',
      value: [1, 4],
      seekMember: '', // 用来写模糊搜索人员的
      equal: 0,
      trpm: {}, // 创建一个tepm
      tree: {},
      sear: '', // 搜索
      showpop: false
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  created() {
    let num = 0
    // this.interval = setInterval(() => {
    //   num++
    //   this.init(num)
    // }, 5000)
  },
  beforeDestroy(){
    clearInterval(this.interval)
  },
  methods: {
    handleClickOutside() {},
    async init(num) {
      const response = await cycleRequest(this.$store.getters.token)
      if (response.code === 200) {
        if (response.data === true && this.showpop !== response.data) {
          // this.$store.commit('urgencyPop', true)
          this.showpop = response.data
        } else {
          this.showpop = response.data
        }
        this.$store.commit('urgencyVuex', response.data)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.elCard {
  position: relative;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
}
.el-card__body {
  padding: 0;
}
.elCard h4 {
  line-height: 40px;
  font-size: 25px;
  margin: 0;
  // height: 40px;
  width: 200px;
}
.elCard button {
  position: relative;
  // left: 15px;
  bottom: 35px;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.showfier {
  height: 1100px;
  width: 100%;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 15;
  background-color: rgba(black, 0.5);
}
.show_left {
  height: 400px;
  background: #fff;
  width: 40%;
  height: 40%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
  background-color: aqua;
}
</style>
